(function () {
  function initializeCustomDeliveryCheck() {
    const globalDeliveryDateSelector = document.getElementById(
      "global-delivery-date-selector"
    );
    const deliveryDateMessage = document.getElementById(
      "custom-delivery-date-message"
    );
    const checkoutButton = document.getElementById("checkout");
    const mixedQuantityMessage = document.getElementById(
      "mixed-quantity-message"
    );
    const noteField = document.getElementById("Cart-note");
    const deliveryMessageContainer = document.getElementById(
      "custom-delivery-message-container"
    );
    const additionalNotesInput = document.querySelector(".cart-notes");
    let stockDateElements = document.querySelectorAll(
      ".custom-product-stock-date"
    );

    // Create popup elements (unchanged)
    const popupContainer = document.createElement("div");
    popupContainer.id = "custom-popup-container";
    popupContainer.style.position = "fixed";
    popupContainer.style.top = "0";
    popupContainer.style.left = "0";
    popupContainer.style.width = "100%";
    popupContainer.style.height = "100%";
    popupContainer.style.display = "flex";
    popupContainer.style.justifyContent = "center";
    popupContainer.style.alignItems = "center";
    popupContainer.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
    popupContainer.style.zIndex = "1000";
    popupContainer.style.visibility = "hidden";

    const popupContent = document.createElement("div");
    popupContent.id = "custom-popup-content";
    popupContent.style.backgroundColor = "#fff";
    popupContent.style.padding = "20px";
    popupContent.style.borderRadius = "5px";
    popupContent.style.textAlign = "center";
    popupContent.style.position = "relative";

    const closeButton = document.createElement("span");
    closeButton.textContent = "×";
    closeButton.style.position = "absolute";
    closeButton.style.top = "10px";
    closeButton.style.right = "10px";
    closeButton.style.cursor = "pointer";
    closeButton.style.fontSize = "20px";

    const popupText = document.createElement("p");
    popupText.textContent =
      "Välj ett önskat leveransdatum innan ni går vidare till checkout";

    const mixedQuantityPopupText = document.createElement("p");
    mixedQuantityPopupText.classList.add("warning-alert");

    popupContent.appendChild(closeButton);
    popupContent.appendChild(popupText);
    popupContent.appendChild(mixedQuantityPopupText);
    popupContainer.appendChild(popupContent);
    document.body.appendChild(popupContainer);

    closeButton.addEventListener("click", () => {
      popupContainer.style.visibility = "hidden";
    });

    function checkMixedQuantities() {
      const quantityElements = document.querySelectorAll(".product-quantity");
      let hasZeroQuantity = false;
      let hasPositiveQuantity = false;
      let totalItems = 0;

      quantityElements.forEach((element) => {
        const quantity = parseInt(element.getAttribute("data-quantity"));
        if (quantity === 0) hasZeroQuantity = true;
        if (quantity > 0) hasPositiveQuantity = true;
        totalItems++;
      });

      if (totalItems >= 2 && hasZeroQuantity && hasPositiveQuantity) {
        const message =
          "Er varukorg innehåller både produkter som är tillgängliga och som är slut på lager. Om ni vill ha ett tidigare leveransdatum än nu, ta bort de som är slut på lager.  ";
        mixedQuantityMessage.textContent = message;
        mixedQuantityMessage.style.display = "block";
        mixedQuantityPopupText.textContent = message;
      } else {
        mixedQuantityMessage.style.display = "none";
        mixedQuantityPopupText.textContent = "";
      }
    }

    function parseDate(dateString) {
      if (dateString === "N/A") return null;

      if (dateString.length === 7) {
        dateString = "0" + dateString;
      }

      const parts = dateString.match(/(\d{2})(\d{2})(\d{4})/);
      if (parts) {
        const [, day, month, year] = parts;
        let parsedDate = new Date(`${year}-${month}-${day}`);
        parsedDate.setHours(0, 0, 0, 0);

        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);

        if (parsedDate <= currentDate) {
          const adjustedDate = new Date();
          adjustedDate.setDate(adjustedDate.getDate() + 3);
          adjustedDate.setHours(0, 0, 0, 0);
          return adjustedDate;
        }

        return parsedDate;
      }
      return null;
    }

    // function formatDate(date) {
    //   const day = String(date.getDate()).padStart(2, "0");
    //   const monthNames = [
    //     "Jan",
    //     "Feb",
    //     "Mar",
    //     "Apr",
    //     "May",
    //     "Jun",
    //     "Jul",
    //     "Aug",
    //     "Sep",
    //     "Oct",
    //     "Nov",
    //     "Dec",
    //   ];
    //   return `${day} ${monthNames[date.getMonth()]} ${date.getFullYear()}`;
    // }

 function formatDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-based, so add 1
  const day = String(date.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
 }
    

    function updateNoteField() {
      const selectedDate = globalDeliveryDateSelector.value;
      const additionalText = additionalNotesInput.value.trim();
      // const dateText = selectedDate
      //   ? `Desired delivery date: ${formatDate(new Date(selectedDate))}`
      //   : "";
      const dateText = selectedDate
        ? `Desired delivery date: ##${formatDate(new Date(selectedDate))}##`
        : "";
      noteField.value = additionalText
        ? `${dateText} - ${additionalText}`
        : dateText;
    }

    function checkAllDates() {
      const selectedDate = new Date(globalDeliveryDateSelector.value);
      selectedDate.setHours(0, 0, 0, 0);

      // Modified to prioritize out-of-stock items
      const quantityElements = document.querySelectorAll(".product-quantity");
      let hasOutOfStock = false;
      let latestOutOfStockDate = new Date(0);

      // First check for out-of-stock items and their dates
      quantityElements.forEach((element, index) => {
        const quantity = parseInt(element.getAttribute("data-quantity"));
        if (quantity <= 0) {
          hasOutOfStock = true;
          const stockDate = parseDate(
            stockDateElements[index].innerText.trim()
          );
          if (stockDate && stockDate > latestOutOfStockDate) {
            latestOutOfStockDate = stockDate;
          }
        }
      });

      // If there are out-of-stock items, use their dates for validation
      if (hasOutOfStock) {
        if (selectedDate < latestOutOfStockDate) {
          deliveryDateMessage.textContent = `Önskat leveransdatum är... ${formatDate(
            latestOutOfStockDate
          )}`;
          deliveryDateMessage.style.display = "block";
          checkoutButton.style.pointerEvents = "none";
          checkoutButton.style.opacity = "0.5";
        } else {
          deliveryDateMessage.textContent = "";
          deliveryDateMessage.style.display = "block";
          checkoutButton.style.pointerEvents = "auto";
          checkoutButton.style.opacity = "1";
        }
      } else {
        // If all items are in stock, use standard 3-day validation
        const threeDaysAhead = new Date();
        threeDaysAhead.setDate(threeDaysAhead.getDate() + 3);
        threeDaysAhead.setHours(0, 0, 0, 0);

        if (selectedDate < threeDaysAhead) {
          deliveryDateMessage.textContent = `Önskat leveransdatum är... ${formatDate(
            threeDaysAhead
          )}`;
          deliveryDateMessage.style.display = "block";
          checkoutButton.style.pointerEvents = "none";
          checkoutButton.style.opacity = "0.5";
        } else {
          deliveryDateMessage.textContent = "";
          deliveryDateMessage.style.display = "block";
          checkoutButton.style.pointerEvents = "auto";
          checkoutButton.style.opacity = "1";
        }
      }
    }

    function setDefaultDate() {
      const quantityElements = document.querySelectorAll(".product-quantity");
      let hasOutOfStock = false;
      let latestOutOfStockDate = new Date(0);

      // Check for out-of-stock items and their dates
      quantityElements.forEach((element, index) => {
        const quantity = parseInt(element.getAttribute("data-quantity"));
        if (quantity <= 0) {
          hasOutOfStock = true;
          const stockDate = parseDate(
            stockDateElements[index].innerText.trim()
          );
          if (stockDate && stockDate > latestOutOfStockDate) {
            latestOutOfStockDate = stockDate;
          }
        }
      });

      let defaultDate;
      if (hasOutOfStock) {
        defaultDate =
          latestOutOfStockDate > new Date() ? latestOutOfStockDate : new Date();
      } else {
        defaultDate = new Date();
        defaultDate.setDate(defaultDate.getDate() + 3);
      }

      const formattedDate = `${defaultDate.getFullYear()}-${String(
        defaultDate.getMonth() + 1
      ).padStart(2, "0")}-${String(defaultDate.getDate()).padStart(2, "0")}`;
      globalDeliveryDateSelector.value = formattedDate;
      // noteField.value = `Desired delivery date: ${formatDate(defaultDate)}`;
        noteField.value = `Desired delivery date: ##${formatDate(defaultDate)}##`;
      checkAllDates();
    }

    function checkCartForMetafields() {
      stockDateElements = document.querySelectorAll(
        ".custom-product-stock-date"
      );
      const hasMetafield = Array.from(stockDateElements).some(
        (element) => element.innerText.trim() !== "N/A"
      );

      if (!hasMetafield) {
        deliveryMessageContainer.style.display = "none";
        checkoutButton.style.pointerEvents = "auto";
        checkoutButton.style.opacity = "1";
        if (stockDateElements.length === 0) {
          noteField.value = "";
        }
      } else {
        deliveryMessageContainer.style.display = "block";
        checkAllDates();
        popupContainer.style.visibility = "visible";
      }

      checkMixedQuantities();
    }

    setDefaultDate();
    checkCartForMetafields();

    const cartObserver = new MutationObserver(() => {
      stockDateElements = document.querySelectorAll(
        ".custom-product-stock-date"
      );
      checkCartForMetafields();
      checkMixedQuantities();
    });

    const cartElement = document.querySelector(".cart");
    if (cartElement) {
      cartObserver.observe(cartElement, { childList: true, subtree: true });
    }

    globalDeliveryDateSelector.addEventListener("change", function (event) {
      event.preventDefault();
      updateNoteField();
      checkAllDates();
    });

    additionalNotesInput.addEventListener("input", updateNoteField);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializeCustomDeliveryCheck
    );
  } else {
    initializeCustomDeliveryCheck();
  }
})();

// document.addEventListener("DOMContentLoaded", function () {
//   let matchingProductsCount = 0; // Count products that match the condition

//   document.querySelectorAll(".cart__row").forEach((item) => {
//     let stockDateElement = item.querySelector(".custom-product-stock-date");
//     let quantityElement = item.querySelector(".product-quantity");

//     // Extract metafield value and quantity
//     let metafieldValue = stockDateElement
//       ? stockDateElement.textContent.trim()
//       : "";
//     let hasMetafield = metafieldValue && metafieldValue !== "N/A"; // Ensure metafield is valid
//     let productQuantity = quantityElement
//       ? parseInt(quantityElement.dataset.quantity, 10)
//       : 0;

//     // 🔥 Debugging Console Logs 🔥
//     console.log("-------------------------");
//     console.log("Product ID:", item.dataset.productId);
//     console.log("Metafield Value:", metafieldValue);
//     console.log("Has Metafield:", hasMetafield);
//     console.log("Product Quantity:", productQuantity);

//     // Count products that have a metafield AND quantity = 0
//     if (hasMetafield && productQuantity === 0) {
//       matchingProductsCount++;
//     }
//   });

//   // Function to show/hide elements
//   function toggleElementVisibility(elementId, shouldShow) {
//     let element = document.getElementById(elementId);
//     if (element) {
//       element.style.display = shouldShow ? "flex" : "none";
//       console.log(
//         `✅ ${elementId} is now ${shouldShow ? "VISIBLE" : "HIDDEN"}`
//       );
//     } else {
//       console.error(`❌ ERROR: ${elementId} not found in the DOM.`);
//     }
//   }

//   // Show both elements only if exactly one matching product is found
//   let shouldShow = matchingProductsCount === 1;
//   toggleElementVisibility("custom-delivery-message-container", shouldShow);
//   toggleElementVisibility("custom-popup-container", shouldShow);
// });
